import React, {Component} from 'react';
import Gallery from 'components/Gallery';
import {connect} from 'react-redux';
import {setWorkDimensions} from 'actions/WorksActions';
import {
	next,
	previous,
	videoEnded,
	randomWork,
	goTo
} from 'actions/NavActions';
import {
	setMouseSide,
	debugVar
} from 'actions/UiActions';
import * as debounce from 'lodash/debounce';
import {
	currentWork,
	currentId
} from 'selectors/worksSelectors';
import {MouseSide} from 'types/UI';
import {Id, Work} from 'types/Work';
import {Location} from 'types/Nav';
import withRouter from 'utils/withRouter';


const mapStateToProps = (state, ownProps) => {
	return {
		router: state.router,
		work: currentWork(state),
		id: currentId(state),
		urlId: ownProps.router?.params?.id,
		mouseSide: state.ui.mouseSide,
		auto: state.ui.auto,
		tapData: state.ui.tapData
	};
}

const mapDispatchToProps = (dispatch, ownProps) => ({
	goTo: (id: Id) => {
		dispatch(goTo(id));
	},
	next: (e: Event) => {
		if (e && e.target){
			e.stopPropagation();
		}
		dispatch(next()).then((nextId) => {
			if (nextId && ownProps.navigate) {
				ownProps.navigate(`/gallery/${nextId}`);
			}
		});
	},
	nextRandom: () => {
		dispatch(randomWork()).then((nextId) => {
			if (nextId && ownProps.navigate) {
				ownProps.navigate(`/gallery/${nextId}`);
			}
		});
	},
	previous: (id?: Id, works?: Work[]) => {
		dispatch(previous()).then((prevId) => {
			if (prevId && ownProps.navigate) {
				ownProps.navigate(`/gallery/${prevId}`);
			}
		});
	},
	navigateTo: (location: Location) => {
		if (ownProps.navigate) {
			ownProps.navigate(location);
		}
	},
	setWorkDimensions: (id: Id, dimensions) => {
		dispatch(setWorkDimensions(id, dimensions));
	},
	setMouseSide: debounce((side: MouseSide) => {
		dispatch(setMouseSide(side));
	}, 25),
	videoEnded: () => {
		dispatch(videoEnded());
	},
	debugVar: (data) => {
		dispatch(debugVar(data));
	}
})

// Wrapper component to handle URL param changes
class GalleryWrapper extends Component<any> {
	componentDidMount() {
		const {urlId, id, goTo} = this.props;
		if (urlId && urlId !== id) {
			goTo(urlId);
		}
	}

	componentDidUpdate(prevProps: any) {
		const {urlId, id, goTo} = this.props;
		if (urlId && urlId !== id && urlId !== prevProps.urlId) {
			goTo(urlId);
		}
	}

	render() {
		const {urlId, goTo, ...restProps} = this.props;
		return React.createElement(Gallery, restProps);
	}
}

const Container = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(GalleryWrapper));
export default Container;
